export default "__VITE_ASSET__9317e980__"